import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

// ui
import FormGroup from '@material-ui/core/FormGroup';

import StormListItem from './StormListItem';
import { StormStatusColor } from './StormColor';

// const textRed = red[900];

export default function StormListJtwc(props) {
  const { t } = useTranslation();
  // debug - should get storm list
  // console.log(props)
  const { data, handleToggleLayer } = props;

  const handleChange = (event) => {
    // console.log(event.target.id, event.target.checked)
    handleToggleLayer(event.target.id, event.target.checked);
  };

  return (
    <>
      <div style={{ overflowY: 'auto', height: 450 }}>
        {data.length === 0 && (
          <>
            {t('ไม่พบข้อมูลพายุ ตามเงื่อนไข')}
          </>
        )}
        <FormGroup>
          {data.map((d) => {
            // console.log(d);
            const color = StormStatusColor(d.metadata.max_wind_speed);
            const statusStyle = {
              backgroundColor: color.color.statusColor,
              color: color.color.constrastColor,
            };

            return (
              <StormListItem
                key={`${d.metadata.name}-${d.metadata.code}`}
                onCheckItem={handleChange}
                item={d}
                statusStyle={statusStyle}
              />
            );
          })}
        </FormGroup>
      </div>
    </>
  );
}

StormListJtwc.propTypes = {
  data: PropTypes.instanceOf(Array).isRequired,
  handleToggleLayer: PropTypes.func.isRequired,
};

export const StormListJtwcMemo = React.memo(StormListJtwc);
